import React from "react";
import "./style.css";
import moment from "moment";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";

const PurchaseDrawerLogsDetails = ({filteredLogs}) => {

  return (
    <div 
      style={{
        marginTop: "40px",
        display: "flex",
        flexDirection: "column" 
      }}>
      <span style={{marginLeft: "8px", fontSize: "16px", fontWeight: "bold", color: "#152935"}}>
        {filteredLogs[0]?.type === "PURCHASE" ?
          <FormattedMessage id="preCog.assetsTab.drawer.logs.purchaseTitle" /> : 
          <FormattedMessage id="preCog.assetsTab.drawer.logs.increaseTitle" /> }
      </span>
      {/* Will be added in the future 
       <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.purchaseDocInfoTitle" />
      </span>
      <div style={{display: "flex"}}>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.docDate" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.docNumber" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.docTaxRegion" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div>
      </div>
    */}
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.docOpsInfoTitle" />
      </span> 
      <div style={{display: "flex", flexWrap: "wrap"}}>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.purchaseDate" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.date === null ? "XXXXXXX" : moment(filteredLogs[0]?.date).format("DD/MM/YYYY")}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.invoiceAmount" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.logAmount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.logAmount).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.nonDeductibleVat" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.nonDeductibleVat === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.nonDeductibleVat).format("0,0.00")} €`}</p>
        </div>
        {/* Will be added in the future
         <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.ancillaryCharges" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div> */}
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.totalToBeDepreciated" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.carryingValue === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.carryingValue).format("0,0.00")} €`}</p>
        </div>
      </div>
    </div>
  );
};

export default PurchaseDrawerLogsDetails;